module.exports = "/_next/static/images/MihaelaPoiata-855877202e0b03b576ef059501ab2407.webp";